import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";

function KpiDetailsPopover({ activitiesWithPoints }) {
  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "100%",
          userSelect: "none",
          overflowY: "auto",
          position: "relative",
          boxShadow: "none",
          borderRadius: 0,
        }}
      >
        <Table aria-label="simple table">
          <TableBody>
            {activitiesWithPoints?.map((kpi) => (
              <TableRow key={kpi.id}>
                <TableCell
                  sx={{
                    padding: "0.4rem .6rem",
                    margin: "0",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Grid container direction="column">
                    <Grid item display="flex">
                      <MDBadgeDot
                        size="lg"
                        sx={{
                          ml: 1,
                          p: 0,
                          i: {
                            background: generateColorFromString(kpi?.KpiActivity?.name),
                          },
                        }}
                      />
                      {kpi?.KpiActivity?.name}
                    </Grid>
                    <Grid item pl={3}>
                      <Typography sx={{ fontSize: "1rem" }}>{`${kpi?.count} ${
                        kpi?.count && kpi.count === 1 ? "kpi" : "kpis"
                      } : ${kpi?.points} ${
                        kpi?.points && kpi.points === 1 ? "point" : "points"
                      }`}</Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default KpiDetailsPopover;
